import React, { useEffect, useState } from 'react';
import { BottomNav, Screen } from './components/BottomNav';
import { PomodoroProvider, usePomodoro } from './contexts/PomodoroContext';
import { AmbientProvider } from './contexts/AmbientContext';
import { TimerScreen } from './pages/TimerScreen';
import { ProgressScreen } from './pages/ProgressScreen';
import { SettingsScreen } from './pages/SettingsScreen';
import { Landing } from './pages/Landing';
import { KEYS, load, save } from './utils/storage';
import { useScreenInit } from './useScreenInit.js';
function ThemeShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    settings
  } = usePomodoro();
  useEffect(() => {
    const root = document.documentElement;
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => {
      const dark = settings.theme === 'dark' || settings.theme === 'system' && media.matches;
      root.classList.toggle('dark', dark);
    };
    apply();
    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [settings.theme]);
  return <>{children}</>;
}
function Shell() {
  const screenInit = useScreenInit();
  const [screen, setScreen] = useState<Screen>(screenInit.screen as Screen ?? 'timer');
  const [entered, setEntered] = useState<boolean>(() => screenInit.entered === undefined ? load<boolean>(KEYS.entered, false) : Boolean(screenInit.entered));
  if (!entered) {
    return <div className="min-h-full w-full bg-bg" data-id="element-0" data-mp="2zmwj72jhrued">
        <Landing onStart={() => {
        save(KEYS.entered, true);
        setEntered(true);
      }} data-id="element-1" data-mp="33m5am0r27g6r" />
      </div>;
  }
  return <div className="min-h-full w-full bg-bg" data-id="element-2" data-mp="38nupxslbeg0n">
      <main className="mx-auto min-h-full w-full max-w-md" data-id="element-3" data-mp="3dl4llpzarnwx">
        {screen === 'timer' && <TimerScreen onOpenSettings={() => setScreen('settings')} data-id="element-4" data-mp="nw2ay2pqvkpi" />}
        {screen === 'progress' && <ProgressScreen data-id="element-5" data-mp="sudlkfnv5z8s" />}
        {screen === 'settings' && <SettingsScreen data-id="element-6" data-mp="ssspumptca9c" />}
      </main>
      <BottomNav active={screen} onChange={setScreen} data-id="element-7" data-mp="36859fxwiety" />
    </div>;
}
export function App() {
  return <PomodoroProvider data-id="element-8" data-mp="3ud1e95yxri91">
      <AmbientProvider data-id="element-9" data-mp="3ubrgkhvzwc2x">
        <ThemeShell data-id="element-10" data-mp="3uc9o4ao3ycq5">
          <Shell data-id="element-11" data-mp="3uf5i5nwu4h9b" />
        </ThemeShell>
      </AmbientProvider>
    </PomodoroProvider>;
}